import { useEffect, useState } from "react";
import { Dropdown, Select, Image, ConfigProvider } from "antd";
import { orderStatusList, paymentStatusList } from "../constant/constants";
import { FOOD_MENU } from "../constant/constants";
import Search from "antd/es/input/Search";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import TableHeaderSorting from "./common/TableHeaderSorting";

/**
 * As it is a globally common component its every field should be designed for common purpose.
 *
 * @param {*} param0
 * @returns
 */
function TableHeaderComponent({
  sortingOptions,
  onChangeSorting,
  searchText,
  setSearchText,
  record,
  pageRoute = "",
  enabledFilters = [],
  isDefaultSortByNeeded = true,
}) {
  const navigate = useNavigate();
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null); // New state for tracking selected payment status

  const addButtonList = [
    {
      key: "1",
      label: (
        <div
          onClick={() => {
            navigate("/food/add");
          }}
        >
          Add Food
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={() => {
            navigate("/set-menu");
          }}
        >
          Add Combo
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div
          onClick={() => {
            navigate("/add-meal-addition");
          }}
        >
          Add Meal Addition
        </div>
      ),
    },
  ];

  const openAddModal = () => {
    record.callback(true);
  };
  const onSearch = (value) => {
    record.search(value);
  };
  const onClear = () => {
    if (record.onClearSearchText === undefined) {
      record.search("");
      return;
    }
    record.onClearSearchText();
  };
  
  const handlePaymentStatusChange = (value) => {
    if (value === undefined) {
      setSelectedPaymentStatus(null);
      record.paymentStatus({ key: -1 });
      return;
    }

    setSelectedPaymentStatus(value);

    const selectedItem = paymentStatusList.find((it) => it.value === value);

    record.paymentStatus(selectedItem);
  };

  const handleOrderStatusChange = (value) => {
    if (value !== undefined) {
      const findById = orderStatusList.find((it) => it.value === value);
      record.orderStatus(findById.label);
    } else {
      record.orderStatus("");
    }
  };

  useEffect(() => {
    setSelectedPaymentStatus(record?.paymentStatusValue || undefined)
  }, [record?.paymentStatusValue]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            zIndexPopup: 1,
          },
          Select: {
            zIndexPopup: 1,
          }
        },
      }}
    >
      <div className="flex flex-row mb-[16px] font-uregular p-[16px] w-full items-center justify-between">
        {!record.isShowDropdownHeader && <div className="font-ubold text-xl">{record.title}</div>}
        {record.isShowDropdownHeader && (
          <div className="flex flex-row items-center gap-3 mr-2">
            {[
              { key: "single", label: FOOD_MENU.SINGLE },
              { key: "combo", label: FOOD_MENU.COMBO },
            ].map((item) => (
              <div
                key={item.key}
                className={`px-2 py-2 text-center rounded-md cursor-pointer text-[16px] transition-colors duration-200 ${
                  record.headerTitle === item.label
                    ? "bg-[#572D86] text-white shadow-md"
                    : "bg-gray-100 hover:bg-gray-200 text-gray-700 border"
                }`}
                onClick={() => record.setHeaderTitle(item.label)}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-row items-center justify-end gap-x-[20px]">
          {/* start payment status dropdown */}
          {record.paymentStatus && (
            <div className="flex flex-row items-center">
              <Select
                className="w-[120px]"
                allowClear={true}
                onChange={handlePaymentStatusChange}
                placeholder="Payment Status"
                value={selectedPaymentStatus}
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                options={paymentStatusList}
              />
            </div>
          )}
          {/* end payment status dropdown */}

          {/* start order status dropdown */}
          {record.orderStatus && (
            <div className="flex flex-row items-center">
              <Select
                className="w-[120px]"
                allowClear={true}
                value={record?.orderStatusValue || undefined} // need to use undefined instead of ''
                onChange={handleOrderStatusChange}
                placeholder="Order Status"
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                options={orderStatusList}
              />
            </div>
          )}
          {/* end order status dropdown */}

          <div className="flex flex-row items-center">
            <Search
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder={record.hint}
              allowClear
              onSearch={onSearch}
              onClear={onClear}
            />
            {enabledFilters.includes("FILTER11") && (
              <div className="flex flex-row items-center mx-[40px]">
                {record.filter11.isLableNeeded && (
                  <div className="font-uregular mx-[8px] text-md whitespace-nowrap">Sort By</div>
                )}
                <div className="flex flex-row items-center">
                  <Select
                    value={record.filter11.value}
                    className={`${record.filter11?.fieldClass || ""}`}
                    onChange={record.filter11.onHandleChangeFilter11}
                    options={record.filter11.options}
                  />
                </div>
              </div>
            )}

            {isDefaultSortByNeeded ? (
              <TableHeaderSorting options={sortingOptions} onChange={onChangeSorting} />
            ) : (
              <div className="w-10"></div>
            )}

            {pageRoute ? (
              <Link to={pageRoute}>
                <div className="pr-[15.2px] pl-[25px] w-[104px] py-[8px] rounded bg-orange text-md font-ubold cursor-pointer flex items-center justify-between">
                  Add
                  <Image src="https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/add.svg" preview={false} />
                </div>
              </Link>
            ) : record.isShowDropdownHeader ? (
              <div className="flex flex-row items-center">
                <Dropdown
                  menu={{
                    items: addButtonList,
                  }}
                  placement="bottomLeft"
                >
                  <div className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer">Add</div>
                </Dropdown>
                <img className="ml-[10px] mr-[20px] w-[12px] h-[12px]" src="https://tabletap-cdn.s3.ap-south-1.amazonaws.com/tabletap-prod/static-assets/chevron.svg" />
              </div>
            ) : (
              <Link>
                <div
                  className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer"
                  onClick={openAddModal}
                >
                  Add
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default TableHeaderComponent;
